function DashboardIcon({ isActive }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.5 10.8333H8.33333V2.5H2.5V10.8333ZM2.5 17.5H8.33333V12.5H2.5V17.5ZM11.6667 17.5H17.5V9.16667H11.6667V17.5ZM11.6667 2.5V7.5H17.5V2.5H11.6667Z"
        fill={isActive ? 'white' : '#6C757D'}
      />
    </svg>
  )
}

export default DashboardIcon
